<template>
	<div class="select-coupon">
		<div class="data-preview">
			<draggable :list="selectedItems" v-bind="{ animation: 120, filter: 'input', preventOnFilter: false }">
				<div v-for="(item, index) in selectedItems" :key="index" class="data-item">
					<i class="el-icon-error icon-close" style="cursor: pointer;" @click="handleDeleteItem(index)"></i>
					<div class="item-inner">
						<span class="mr-5">{{ item.name }}</span>
						<span class="mr-5">（ID: {{ item.coupon_id }}）</span>
					</div>
				</div>
			</draggable>
		</div>
		<div class="data-add">
			<el-button @click="handleSelectCoupon()">选择优惠券</el-button>
		</div>
		<!-- <CouponModal
      ref="CouponModal"
      :maxNum="maxNum"
      :defaultList="selectedItems"
      @handleSubmit="handleSelectCouponSubmit"
    />-->
		<NewCouponModal ref="NewCouponModal" :maxNum="maxNum" :defaultList="selectedItems"
			@handleSubmit="handleSelectCouponSubmit" />
	</div>
</template>

<script>
	// import PropTypes from 'ant-design-vue/es/_util/vue-types'
	import draggable from 'vuedraggable'
	import {
		pick,
		cloneDeep
	} from 'lodash'
	import {
		NewCouponModal
	} from '@/views/apps/weishop/components/Modal'
	import { isRegionScope, resolveWeiShopApi } from "@/views/apps/weishop/region/utils/regionApiMap";
	import { appendCurrentRegionStore } from "@/views/apps/weishop/region/mixins/regionPageAdapter";

	function withRegionStoreParams(params) {
		return isRegionScope() ? appendCurrentRegionStore(params) : (params || {});
	}

	// 仅需要的字段
	const itemColumns = ['coupon_id', 'name', 'coupon_type', 'reduce_price', 'discount', 'min_price']

	// 优惠券选择器组件(仅适用于页面设计)
	export default {
		name: 'SelectCoupon',
		components: {
			NewCouponModal,
			draggable
		},
		model: {
			prop: 'value',
			event: 'change'
		},
		props: {
			// 最大选择的数量限制, multiple模式下有效
			maxNum: 15,
			// 选中的优惠券数据
			value: []
		},
		data() {
			return {
				// 已选择的优惠券列表
				selectedItems: []
			}
		},
		watch: {
			value: {
				// 首次加载的时候执行函数
				immediate: true,
				handler(val) {
					this.onUpdate(val)
				}
			}
		},
		created() {},
		methods: {

			// 更新已选择的数据 selectedItems
			onUpdate(items) {
				console.log("items", items)
				this.selectedItems = items
				this.onChange()
			},
			// 打开优惠券选择器
			handleSelectCoupon() {
				this.$refs.NewCouponModal.handle()
			},

			// 优惠券库modal确认回调
			handleSelectCouponSubmit(result) {
				console.log("e", result)
				let _this = this
				if(result.selectedItems.length>0){
					// const { selectedItems } = result
					_this.axios.get(resolveWeiShopApi("/api/weishop/admin/market/coupon/list/ids"), {
							params: withRegionStoreParams({
								page: 1,
								limit: 1000,
								ids:result.selectedItems
							})
						})
						.then((res) => {
							if (res.code == 200) {
								// _this.options = res.data.data;
								_this.onUpdate(_this.filterItems(res.data.data))
							} else {
								eltips(res.msg, "error");
							}
						});
					// 
				}
				
			},

			// 过滤仅需要的数据
			filterItems(selectedItems) {
				return selectedItems.map(itm => pick(itm, itemColumns))
			},

			// 删除优惠券
			handleDeleteItem(index) {
				const {
					selectedItems
				} = this
				if (selectedItems.length <= 1) {
					this.$message.warning('请至少保留1个', 1)
					return
				}
				selectedItems.splice(index, 1)
				this.onUpdate(selectedItems)
			},

			// 触发change事件
			onChange() {
				const {
					selectedItems
				} = this
				return this.$emit('change', selectedItems)
			}

		}
	}
</script>

<style lang="less" scoped>
	// 优惠券信息
	.data-preview {
		.data-item {
			margin: 10px 5px;
			background: #f7fafc;
			position: relative;
			border-radius: 3px;
			cursor: move;
			border: 1px solid #fff;

			&:hover {
				border: 1px solid #dadada;

				.icon-close {
					display: block;
				}
			}
		}

		// 删除图标
		.icon-close {
			display: none;
			position: absolute;
			top: -8px;
			right: -8px;
			cursor: pointer;
			font-size: 16px;
			color: #c5c5c5;

			&:hover {
				color: #7d7d7d;
			}
		}

		.item-inner {
			padding: 10px 15px;
			border-radius: 4px;
			background: #f7fafc;
		}
	}

	// 新增数据
	.data-add {
		margin-top: 10px;

		button {
			width: 100%;
			color: #479cf7;
			height: 40px;
			border-radius: 5px;
			font-size: 12px;
			border-color: #cccccc21;

			&:hover {
				border-color: #479cf7;
			}
		}
	}
</style>
